export default {"src":"/_next/static/media/merge-logo.845efb85.svg","height":24,"width":91,"blurWidth":0,"blurHeight":0};